import { MutationTree } from "vuex";
import { SettingsState, initSettingsState } from "./state";
import { SessionSettingsModel } from "@/models";
import { defineVuexName, MODULES } from "@/store/utils";

const mutations: MutationTree<SettingsState> = {
  [defineVuexName(MODULES.REALTIME_SETTINGS.COMMITS.SET_SETTINGS)](state: SettingsState, payload: SessionSettingsModel | null) {
    state.channels = payload?.channels ?? null;
  },
  [defineVuexName(MODULES.REALTIME_SETTINGS.COMMITS.RESET_STATE)](state: SettingsState) {
    Object.assign(state, initSettingsState());
  },
};

export default mutations;
